import React from "react";
import './CustomerDetailsContainer.scss';
import homelaneLogo from '../assets/icons/homelane.png'
import doowupLogo from '../assets/icons/doowup.png'
import handle1Img from './images/hing1.png';
import { connect } from "react-redux";
import EditIcon from "components/editIcon";
import {inputDqcData,exportDrawing} from './../actions/wizard'
import {ReactComponent as WrapzapLogo} from '../assets/icons/wrapzapLogo.svg';
import {ReactComponent as CubicoLogo} from '../assets/icons/cubicoLogo.svg';
import {ReactComponent as DesignCafeLogo } from '../assets/icons/designCafeLogo.svg';


const NOTES_DEFAULT_FONT_SIZE = 9;
const NOTES_MIN_FONT_SIZE = 6;
const NOTES_FONT_STEP = 0.5;

class CustomerDetailsContainer extends React.Component<any, any>{
    containerRef = React.createRef<HTMLDivElement>();
    detailsRef = React.createRef<HTMLDivElement>();
    notesRef = React.createRef<HTMLDivElement>();

    onEditDqc = () =>{
        this.props.inputDqcData({isDqcDataPresent:false,dqcUpdateMode:true,dqcAddMode:false});
       // this.props.exportDrawing({projectData:this.props.projectData});
    }

    componentDidMount() {
        this.fitNotesToContainer();
    }

    componentDidUpdate() {
        this.fitNotesToContainer();
    }

    // This page is captured as-is into the exported PDF, so the notes text can
    // never scroll or clip silently — it has to actually fit. Since notes are
    // free-form user text with no length limit, we measure the space actually
    // left over after the customer details list and shrink the notes font
    // just enough for everything to be visible.
    fitNotesToContainer = () => {
        const container = this.containerRef.current;
        const notes = this.notesRef.current;
        if (!container || !notes) return;

        const detailsHeight = this.detailsRef.current ? this.detailsRef.current.getBoundingClientRect().height : 0;
        const availableHeight = container.getBoundingClientRect().height - detailsHeight;
        if (availableHeight <= 0) return;

        notes.style.maxHeight = `${availableHeight}px`;
        notes.style.overflow = 'hidden';

        let fontSize = NOTES_DEFAULT_FONT_SIZE;
        notes.style.fontSize = `${fontSize}px`;
        while (notes.scrollHeight > notes.clientHeight && fontSize > NOTES_MIN_FONT_SIZE) {
            fontSize -= NOTES_FONT_STEP;
            notes.style.fontSize = `${fontSize}px`;
        }
    }

    render() {
        const { customer_details, type, notes, roomName,pageDetails,exportDrawingStatus,previewMode,orderProfileType} = this.props;
        const customerDetails = customer_details;
        let essentialNotes = pageDetails?.essentialNotes;
        let custDetailKeys = [];
        if(customerDetails)
           custDetailKeys = Object.keys(customerDetails); 
        return (
            <div className="page-right-container" ref={this.containerRef}>
                <div className="customer-details" ref={this.detailsRef}>
                    <ul className="customer-details-list">
                        {
                            orderProfileType ? ( orderProfileType ==='DOOWUP' ? <img  src={doowupLogo} alt="Logo" className={'hlLogo'}/> :  orderProfileType === 'WRAPZAP' ? <WrapzapLogo /> : customerDetails?.displayProfile?.toLowerCase() === 'cubico' ? <CubicoLogo className={'hlLogo'} /> : ['dc', 'designcafe'].includes(orderProfileType?.toLowerCase()) ? <DesignCafeLogo /> : <img  alt="Logo" src={homelaneLogo} className={'hlLogo'}/>): ""
                        }
                         <li className="customer-details-list-item" key={0}>
                                <span className="right-container-heading">{`2D Drawing - ${roomName ? roomName: ""}`}</span>
                        </li>    
                        {
                            custDetailKeys.length  && custDetailKeys.map((key, index)=>{
                                const value = customerDetails[key];
                                let ckey = key.replace(/_/g, " ");
                                if(typeof value == 'object'){
                                    return (
                                        <li className="customer-details-list-item" key={index}>
                                            <span className="right-container-heading"><b>{ckey}</b>{(key==='DQC_Manager'&& previewMode !== 'enabled' && exportDrawingStatus !== 'inprogress') && <EditIcon onClick={this.onEditDqc}/>}</span>
                                            <span className="content">{value?.name}</span><br/>
                                            <span className="content">{value?.emailId}</span> 
                                         </li>
                                    )
                                }
                                return(
                                    <li className="customer-details-list-item" key={index}>
                                        <p className="right-container-heading"><b>{ckey}</b></p>
                                        <span className="content">{value}</span>
                                    </li>
                                )  
                            })
                        }                    
                    </ul>
                </div>
                {
                    (essentialNotes || notes) ? <div className="roomPageNotes" ref={this.notesRef}><span>Notes</span>
                        {
                            ((essentialNotes || notes) || "").split('\n').map(i => {
                                return <p key={i}>{i.trim()}</p>
                            })
                        }
                    </div> : ""
                }
                {
                    type === "elevation2" ?
                        <div className="sidebar-image">
                            <div className="hing-heading">HING/HANDLE POSITION</div>
                            <img className="hing-image" crossOrigin="anonymous" src={handle1Img ? `${handle1Img}?ver=${new Date().getTime()}`:""} alt="handleImage"></img>
                        </div>
                    :"" 
                }
            </div>
        )
    }

}
export default connect(
    (state: any) => ({
        customer_details: state.wizard.customer_details,
        isDqcDataPresent:state.wizard.isDqcDataPresent,
        projectData: state.wizard.projectData,
        pageDetails: state.wizard.pageDetails,
        notes: state.wizard.notes,
        roomName: state.wizard.roomName,
        exportDrawingStatus: state.wizard.exportDrawingStatus,
        previewMode: state.wizard.previewMode,
        orderProfileType: state.wizard.orderProfileType
    }),
    {      
        inputDqcData,
        exportDrawing
    }
)(CustomerDetailsContainer);